import { createLink } from '@tanstack/react-router'
import type { AnchorHTMLAttributes, HTMLAttributes, ReactNode, Ref } from 'react'
import { cn } from '@/shared/lib'

interface CardProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode
}

export function Card({ className, children, ...rest }: CardProps) {
  return (
    <div className={cn('rounded-card bg-card p-4', className)} {...rest}>
      {children}
    </div>
  )
}

interface CardAnchorProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
  active?: boolean
  ref?: Ref<HTMLAnchorElement>
}

function CardAnchor({ active = false, className, children, ...rest }: CardAnchorProps) {
  return (
    <a
      className={cn(
        'block w-full rounded-card p-4 text-left transition-colors',
        active ? 'bg-grad-active text-white' : 'bg-card hover:bg-hover',
        className,
      )}
      {...rest}
    >
      {children}
    </a>
  )
}

// Карточка master-списка: выбор сущности — навигация, а не локальное состояние.
export const CardLink = createLink(CardAnchor)
